export const validation = {
  password: "Password is required",
  email: "Email is required",
  validEmail: "Please enter valid email address",
  validPassword: "Password Must be 6 to 15 Characters",
  firstName: "First name is required",
  lastName: "Last name is required",
  companyName: "Company name is required",
  phoneNumber: "Phone number is required",
  validPhoneNumber: "Please enter valid phone number",
  phoneNumberShort: "Phone number must not be less than 6 digit",
  phoneNumberLong: "Phone number must not be more than 12 digit",
};
